import React, { useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import {
  Box,
  styled,
  Grid,
  Typography,
  Button,
  InputAdornment,
  TextField,
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import PageHeader from '../../../components/PageHeader';
// import ChartInOutEachGate from './ChartInOutEachGate';
import ChartNumberInOut from './ChartNumberInOut';
import SummaryNumberInOut from './SummaryNumberInOut';
import TableInOutEachGate from './TableInOutEachGate';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { api } from '../../../api';
import { Company } from '../../../schema/company';
import { Area } from '../../../schema/area';
import { Gate, GateGroup } from '../../../schema/gate';
import { ScanType } from '../../../schema/log';
import { PersonType } from '../../../schema/person';
import MultiSelect from '../../../components/MultiSelect';

import { formatDate } from '../../../util';
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';

const NumberInOut = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const [filterID, setFilterID] = useState<string>('');
  const [filterName, setFilterName] = useState<string>('');
  const [filterGateIDList, setFilterGateIDList] = useState<number[]>([]);
  const [filterAreaIDList, setFilterAreaIDList] = useState<number[]>([]);
  const [filterCompanyIDList, setFilterCompanyIDList] = useState<number[]>([]);
  const [filterPersonTypeIDList, setFilterPersonTypeIDList] = useState<string[]>([]);
  const [filterScanTypes, setFilterScanTypes] = useState<string[]>([]);
  const [filterStartDate, setFilterStartDate] = useState<Date | null>(today);
  const [filterEndDate, setFilterEndDate] = useState<Date | null>(null);
  const [filterGateGroupIDList, setFilterGateGroupIDList] = useState<number[]>([]);

  const [filterID2, setFilterID2] = useState<string>('');
  const [filterName2, setFilterName2] = useState<string>('');
  const [filterGateIDList2, setFilterGateIDList2] = useState<number[]>([]);
  const [filterAreaIDList2, setFilterAreaIDList2] = useState<number[]>([]);
  const [filterCompanyIDList2, setFilterCompanyIDList2] = useState<number[]>([]);
  const [filterPersonTypeIDList2, setFilterPersonTypeIDList2] = useState<string[]>([]);
  const [filterScanTypes2, setFilterScanTypes2] = useState<string[]>([]);
  const [filterStartDate2, setFilterStartDate2] = useState<Date | null>(today);
  const [filterEndDate2, setFilterEndDate2] = useState<Date | null>(null);
  const [filterGateGroupIDList2, setFilterGateGroupIDList2] = useState<number[]>([]);

  const [companies, setCompanies] = useState<Company[]>([]);
  const [searchCompanyKeyword, setSearchCompanyKeyword] = useState<string>('');
  const [areas, setAreas] = useState<Area[]>([]);
  const [gates, setGates] = useState<Gate[]>([]);
  const [gategroups, setGateGroups] = useState<GateGroup[]>([]);
  const [personTypes, setPersonTypes] = useState<PersonType[]>([]);
  const [scanTypes, setScanTypes] = useState<ScanType[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isExportLoading, setIsExportLoading] = useState<boolean>(false);

  const handleExportCSVFile = () => {
    if (isExportLoading) {
      return;
    }
    const searchParams = new URLSearchParams();
    if (filterID2) {
      searchParams.set('personal_id', `${filterID2}`);
    }
    if (filterName2) {
      searchParams.set('name', `${filterName2}`);
    }
    if (filterGateIDList2) {
      filterGateIDList2.forEach((gate_id) => {
        searchParams.append('gate_id', `${gate_id}`);
      });
    }
    if (filterAreaIDList2) {
      filterAreaIDList2.forEach((area_id) => {
        searchParams.append('area_id', `${area_id}`);
      });
    }
    if (filterCompanyIDList2.length) {
      filterCompanyIDList2.forEach((company_id) => {
        searchParams.append('company_id', `${company_id}`);
      });
    }
    if (filterPersonTypeIDList2.length) {
      filterPersonTypeIDList2.forEach((person_type_id) => {
        searchParams.append('person_type_id', `${person_type_id}`);
      });
    }
    if (filterScanTypes2.length) {
      filterScanTypes2.forEach((type_id) => {
        searchParams.append('type_id', `${type_id}`);
    });
    }
    if (filterStartDate2) {
      searchParams.set('start_date', `${filterStartDate2.toISOString()}`);
    }
    if (filterEndDate2) {
      searchParams.set('end_date', `${filterEndDate2.toISOString()}`);
    }
    if (filterGateGroupIDList2) {
      filterGateGroupIDList2.forEach((gategroup_id) => {
        searchParams.append('gategroup_id', `${gategroup_id}`);
      });
    }

    setIsExportLoading(true);
    api
      .get(`/scan-in-out/export`, { params: searchParams, responseType: 'blob' })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'scan-in-out_export_data.xlsx');
        document.body.appendChild(link);
        link.click();
      })
      .finally(() => setIsExportLoading(false));
  };

  const handleEnterToSearch = () => {
    setIsLoading(true);

    setFilterID2(filterID);
    setFilterName2(filterName);
    setFilterGateIDList2(filterGateIDList);
    setFilterAreaIDList2(filterAreaIDList);
    setFilterCompanyIDList2(filterCompanyIDList);
    setFilterPersonTypeIDList2(filterPersonTypeIDList);
    setFilterScanTypes2(filterScanTypes);
    setFilterStartDate2(filterStartDate);
    setFilterEndDate2(filterEndDate);
    setFilterGateGroupIDList2(filterGateGroupIDList);
    
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  };

  useEffect(() => {
    api.get<Company[]>(`/company`).then((res) => {
      const { data } = res;
      setCompanies(data);
    });
    api.get<PersonType[]>(`/person-type`).then((res) => {
      const { data } = res;
      setPersonTypes(data);
    });
    api.get<Gate[]>(`/gate`).then((res) => {
      const { data } = res;
      setGates(data);
    });
    api.get<GateGroup[]>(`/gate-group`).then((res) => {
      const { data } = res;
      setGateGroups(data);
    });
    api.get<Area[]>(`/area`).then((res) => {
      const { data } = res;
      setAreas(data);
    });
    api.get<ScanType[]>(`/acc_device_scan_type`).then((res) => {
      const { data } = res;
      setScanTypes(data);
    });
  }, []);

  useEffect(() => {
    if (searchCompanyKeyword) {
      const timeOut = setTimeout(() => {
        const searchParams = new URLSearchParams();
        searchParams.set('company_name', searchCompanyKeyword);
        searchParams.set('limit', '10');

        api.get<Company[]>(`/company`, { params: searchParams }).then((res) => {
          const { data } = res;
          setCompanies(data);
        });
      }, 500);
      return () => clearTimeout(timeOut);
    }
  }, [searchCompanyKeyword]);

  return (
    <Container>
      <PageHeader text="จำนวนบุคคลเข้าออกพื้นที่" />

      <Box sx={{ marginTop: 2 }}>
        <SummaryNumberInOut
          filterID={filterID2}
          filterName={filterName2}
          filterGateIDList={filterGateIDList2}
          filterAreaIDList={filterAreaIDList2}
          filterCompanyIDList={filterCompanyIDList2}
          filterPersonTypeIDList={filterPersonTypeIDList2}
          filterScanTypes={filterScanTypes2}
          filterStartDate={filterStartDate2}
          filterEndDate={filterEndDate2}
          filterGateGroupIDList={filterGateGroupIDList2}
        />
        <ChartNumberInOut
          filterID={filterID2}
          filterName={filterName2}
          filterGateIDList={filterGateIDList2}
          filterAreaIDList={filterAreaIDList2}
          filterCompanyIDList={filterCompanyIDList2}
          filterPersonTypeIDList={filterPersonTypeIDList2}
          filterScanTypes={filterScanTypes2}
          filterStartDate={filterStartDate2}
          filterEndDate={filterEndDate2}
          filterGateGroupIDList={filterGateGroupIDList2}
        />
        {/* <ChartInOutEachGate
          filterID={filterID2}
          filterName={filterName2}
          filterGateIDList={filterGateIDList2}
          filterAreaIDList={filterAreaIDList2}
          filterCompanyIDList={filterCompanyIDList2}
          filterPersonTypeIDList={filterPersonTypeIDList2}
          filterScanTypes={filterScanTypes2}
          filterStartDate={filterStartDate2}
          filterEndDate={filterEndDate2}
        /> */}
        {/* <TableNumberInOut /> */}

        <Paper sx={{ my: 2 }}>
          <Box display="flex" justifyContent="space-between" sx={{ p: 2, pb: 0 }}>
            <Typography variant="h6" display="inline" sx={{ py: 1 }}>
              จำนวนบุคคลเข้าออก
            </Typography>
            <Box>
              <Button variant="outlined" onClick={handleExportCSVFile} disabled={isExportLoading}>
                Export
              </Button>
              <Button style={{ marginLeft: 10 }} variant="outlined" onClick={handleEnterToSearch}>
                ค้นหา
              </Button>
            </Box>
          </Box>
          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid item md={3}>
              <TextField
                id="search-text-label"
                label="ค้นหาเลขบัตรประชาชน"
                variant="outlined"
                placeholder="ค้นหาเลขบัตรประชาชน"
                onChange={(event) => setFilterID(event.target.value)}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
                autoComplete="off"
              />
            </Grid>
            <Grid item md={3}>
              <TextField
                id="search-text-label"
                label="ค้นหาชื่อ - นามสกุล"
                variant="outlined"
                placeholder="ค้นหาชื่อ - นามสกุล"
                onChange={(event) => setFilterName(event.target.value)}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
                autoComplete={'off'}
              />
            </Grid>
            <Grid item md={3}>
              <MultiSelect
                options={personTypes.map((data) => ({
                  id: data.id.toString(),
                  name: data.type_name
                }))}
                onChange={(data) => setFilterPersonTypeIDList(data)}
                label="ประเภทบุคคล"
              />
            </Grid>
            <Grid item md={3}>
              <Autocomplete
                multiple
                limitTags={2}
                disablePortal
                options={companies}
                getOptionLabel={(option) => option.company_name}
                renderInput={(params) => <TextField {...params} label="บริษัท" fullWidth />}
                onChange={(_, value) => setFilterCompanyIDList(value.map((data) => data.id))}
                onInputChange={(_, newInputValue) => {
                  setSearchCompanyKeyword(newInputValue);
                }}
                fullWidth
              />
            </Grid>
            <Grid item md={3}>
              <Autocomplete
                multiple
                limitTags={2}
                disablePortal
                options={gates}
                getOptionLabel={(option) => option.gate_name}
                renderInput={(params) => <TextField {...params} label="ประตู" fullWidth />}
                onChange={(_, value) => setFilterGateIDList(value.map((data) => data.id))}
                fullWidth
              />
            </Grid>
            <Grid item md={3}>
              <Autocomplete
                multiple
                limitTags={2}
                disablePortal
                options={gategroups}
                getOptionLabel={(option) => option.group_name}
                renderInput={(params) => <TextField {...params} label="กลุ่มประตู" fullWidth />}
                onChange={(_, value) => setFilterGateGroupIDList(value.map((data) => data.id))}
                fullWidth
              />
            </Grid>
            <Grid item md={3}>
              <Autocomplete
                multiple
                limitTags={2}
                disablePortal
                options={areas}
                getOptionLabel={(option) => option.area_name}
                renderInput={(params) => <TextField {...params} label="พื้นที่" fullWidth />}
                onChange={(_, value) => setFilterAreaIDList(value.map((data) => data.id))}
                fullWidth
              />
            </Grid>
            <Grid item md={3}>
              {/* <LocalizationProvider dateAdapter={AdapterDateFns}> */}
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateTimePicker
                  label="วันที่เริ่มต้น"
                  inputFormat="dd/MM/yyyy HH:mm"
                  // value={filterStartDate}
                  // onChange={(value) => setFilterStartDate(value)}
                  // renderInput={(params) => <TextField {...params} fullWidth />}
                  value={filterStartDate}
                  onChange={(value) => setFilterStartDate(value)}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item md={3}>
              {/* <LocalizationProvider dateAdapter={AdapterDateFns}> */}
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateTimePicker
                  label="วันที่สิ้นสุด"
                  inputFormat="dd/MM/yyyy HH:mm"
                  // value={filterEndDate}
                  // onChange={(value) => setFilterEndDate(value)}
                  // renderInput={(params) => <TextField {...params} fullWidth />}
                  value={filterEndDate}
                  onChange={(value) => setFilterEndDate(value)}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item md={3}>
  
                <MultiSelect
                options={scanTypes.map((data) => ({
                  id: data.id.toString(),
                  name: data.type_name
                }))}
                onChange={(data) => setFilterScanTypes(data)}
                label="เข้าออก"
              />
               
            </Grid>
          </Grid>
        </Paper>

        <TableInOutEachGate
          filterID={filterID2}
          filterName={filterName2}
          filterGateIDList={filterGateIDList2}
          filterAreaIDList={filterAreaIDList2}
          filterCompanyIDList={filterCompanyIDList2}
          filterPersonTypeIDList={filterPersonTypeIDList2}
          filterScanTypes={filterScanTypes2}
          filterStartDate={filterStartDate2}
          filterEndDate={filterEndDate2}
          filterGateGroupIDList={filterGateGroupIDList2}
        />
      </Box>
    </Container>
  );
};

export default NumberInOut;

const Container = styled('div')`
  padding: 16px;
`;
